import apiBase from './apiBase';
import dataUriToBlob from '../utils/dataUriToBlob';

export default class PublicSurveyApi {
  static get() {
    return apiBase.get('/public/consultation-surveys');
  }

  static getDetails(id) {
    return apiBase.get(`/public/consultation-surveys/${id}`);
  }

  static deleteSubmissionTemporaryFile(surveyId, questionId, fileId) {
    return apiBase.delete(`public/consultation-surveys/${surveyId}/${questionId}/files/${fileId}`, {}, { withCredentials: true });
  }

  static submitSurvey(id, data) {
    const payload = { ...data };

    if (payload.respondent && payload.respondent.teryt && payload.respondent.teryt.streetCode === 'brak') {
      payload.respondent.teryt.streetCode = null;
      payload.respondent.address = null;
    }
    payload.answers = payload.answers.map(a => (
      {
        ...a,
        selectedAnswersIds: a.selectedAnswersIds ? a.selectedAnswersIds.map(s => s === "own" ? null : s) : null,
        newProposedLocations: a.locations ? a.locations.proposed : null,
        existingProposedLocations: a.locations ? a.locations.existing : null,
        files: a.files
          ? a.files.map(f => ({
            fileId: f.fileId,
            fileName: f.fileName,
            fileType: f.fileType,
            fileSize: f.fileSize,
          }))
          : null,
      }));
    return apiBase.post(`/public/consultation-surveys/${id}/submit`, payload);
  }

  static startPhoneNumberVerification(id, phoneNumber, verificationMethodId) {
    return apiBase.post(`/public/consultation-surveys/${id}/start-phone-number-verification`, { phoneNumber, verificationMethodId });
  }

  static verifySurveySubmission(id, submissionId) {
    return apiBase.post(`/public/consultation-surveys/${id}/verify/${submissionId}`);
  }

  static addComment(id, data) {
    return apiBase.post(`/public/consultation-surveys/${id}/act/comments`, data);
  }

  static getThreads(id) {
    return apiBase.get(`/public/consultation-surveys/${id}/board/threads`);
  }

  static getPosts(surveyId, threadId, limit, offset) {
    return apiBase.get(`/public/consultation-surveys/${surveyId}/board/threads/${threadId}?postsLimit=${limit}&postsOffset=${offset}`);
  }

  static addPost(id, threadId, data) {
    const formData = new FormData();
    formData.append('content', data.content);
    if (data.files) {
      data.files.filter(f => f.file && f.file.data).forEach(file => {
        const fileData = dataUriToBlob(file.file.data);
        if (fileData) formData.append('files', fileData, file.file.name);
      });
    }

    if (data.images) {
      data.images.filter(f => f.file).forEach(file => {
        const fileData = dataUriToBlob(file.file.url);
        if (fileData) formData.append('images', fileData, file.file.name);
      });
    }

    return apiBase.post(`/public/consultation-surveys/${id}/board/threads/${threadId}/posts`, formData);
  }

  static createThread(id, data) {
    const formData = new FormData();
    formData.append('title', data.title);
    formData.append('content', data.content);
    if (data.files) {
      data.files.filter(f => f.file && f.file.data).forEach(file => {
        const fileData = dataUriToBlob(file.file.data);
        if (fileData) formData.append('files', fileData, file.file.name);
      });
    }

    if (data.images) {
      data.images.filter(f => f.file).forEach(file => {
        const fileData = dataUriToBlob(file.file.url);
        if (fileData) formData.append('images', fileData, file.file.name);
      });
    }

    return apiBase.post(`/public/consultation-surveys/${id}/board/threads`, formData);
  }

  static react(id, threadId, postId, reaction) {
    return apiBase.post(`/public/consultation-surveys/${id}/board/threads/${threadId}/posts/${postId}/reactions`, { reaction });
  }

  static undoReact(id, threadId, postId, reaction) {
    return apiBase.delete(`/public/consultation-surveys/${id}/board/threads/${threadId}/posts/${postId}/reactions/${reaction}`);
  }
}



// WEBPACK FOOTER //
// ./src/api/publicSurveyApi.js